import { DatePipe } from '@angular/common'
import { Component, OnInit, DestroyRef, inject } from '@angular/core'
import { MatTableDataSource } from '@angular/material/table'
import { MatDialog } from '@angular/material/dialog'
import { ActivatedRoute, Router } from '@angular/router'
import { UnespCoreMessageService } from 'src/libs/unesp-core'
import { ComissaoJulgadoraService } from '../../comissao-julgadora/comissao-julgadora-service'
import { ListagensDiversasService } from 'src/app/services/listagens-diversas.service'
import { ResultadoClassificacaoLinha } from 'src/app/models/ComissaoResultadoInscricaoDTO'
import { AndamentoService } from 'src/app/services/andamento.service'
import { ReporteIdentificacaoService } from 'src/app/services/reporte-identificacao.service'
import { JustificativaInfoDialogComponent } from '../../comissao-julgadora/lista-classificacao-examinador/justificativa-info-dialog/justificativa-info-dialog.component'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

@Component({
  selector: 'app-resumo-classificacao',
  templateUrl: './resumo-classificacao.component.html',
  styleUrls: ['./resumo-classificacao.component.scss'],
})
export class ResumoClassificacaoComponent implements OnInit {
  private destroyRef = inject(DestroyRef)

  colunasClassificacaoGrid: string[] = []
  colunasGrid: string[] = ['classificacao', 'inscricaoId', 'nome', 'nascimento', 'conceito', 'indicacoes']
  colunasFase1Grid: string[] = ['classificacao', 'inscricaoId', 'nome', 'nascimento', 'mediaFinal']
  
  dataSourceFase2: MatTableDataSource<any> = new MatTableDataSource()
  dataSourceFase1: MatTableDataSource<any> = new MatTableDataSource()
  dataSourceClassificacaoFase2: MatTableDataSource<ResultadoClassificacaoLinha> = new MatTableDataSource()
  dataSourceClassificacaoFase1: MatTableDataSource<ResultadoClassificacaoLinha> = new MatTableDataSource()
  
  datepipe: DatePipe = new DatePipe('pt-BR')
  concursoId: number = 0
  retificado: boolean = false
  headerRowFase2: string[] = []
  headerRowFase1: string[] = []
  mappedDataFase2: any[] = []
  mappedDataFase1: any[] = []
  
  tiposProva: string[] = []
  tipoProvaSelecionado: string = ''
  notasPorTipo: { [key: string]: any[] } = {}
  colunasPorTipo: { [key: string]: string[] } = {}
  examinadoresInfoFase2: { [key: string]: { name: string, comissaoId: string, matricula?: string } } = {}
  examinadoresInfoFase1: { [key: string]: { name: string, comissaoId: string, matricula?: string } } = {}
  comissoesInfo: { [key: string]: { nome: string, matricula?: string } } = {}
  tipoConcurso: string = ''
  reportesVisiveis: any[] = []
  faseProvaEscrita: string = ''
  constructor(
    private router: Router,
    private unespCoreMessageService: UnespCoreMessageService,
    private route: ActivatedRoute,
    private listagensDiversasService: ListagensDiversasService,
    private comissaoJulgadoraService: ComissaoJulgadoraService,
    private andamentoService: AndamentoService,
    private dialog: MatDialog,
    private reporteIdentificacaoService: ReporteIdentificacaoService,
  ) {}

  ngOnInit() {
    this.concursoId = Number(this.route.snapshot.paramMap.get('id'))
    if (!this.concursoId) {
      this.unespCoreMessageService.showMessageError('Concurso não encontrado na rota.')
      return
    }
    this.andamentoService.possuiRecursoDeferidoResultadoFinal(this.concursoId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(r => this.retificado = r)
    this.loadData()
    this.reporteIdentificacaoService.listarVisiveis(this.concursoId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => this.reportesVisiveis = data)
  }

  loadData() {
    this.listagensDiversasService.buscarResumoNotasAdmin(this.concursoId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data) => this.processarResumoNotas(data),
      error: (err) => console.error('Erro ao carregar resumo das notas:', err)
    })

    this.comissaoJulgadoraService.getClassificacaoPorConcurso(this.concursoId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data: any) => {
        if (data.faseProvaEscrita) {
          this.faseProvaEscrita = data.faseProvaEscrita === 'FASE1' ? 'fase1' : 'fase2'
        }
        if (data.fase1 && data.fase1.length > 0) {
          this.processarFase(data.fase1, 'fase1')
        }
        if (data.fase2 && data.fase2.length > 0) {
          this.processarFase(data.fase2, 'fase2')
        }
      },
      error: (err) => {
        this.unespCoreMessageService.showMessageError(
          err?.error?.message ?? 'Erro ao carregar classificação.'
        )
      }
    })
  }

  processarFase(dados: any[], fase: 'fase1' | 'fase2') {
    if (dados.length > 0 && dados[0].tipoConcurso) {
      this.tipoConcurso = dados[0].tipoConcurso
    }

    const mappedData = dados.map((item: any, index: number) => {
      const nascimento = item.nascimento
      const idade = this.calcularIdade(nascimento)
      const desclassificadoPorReporte = this.isDesclassificadoPorReporte(item.inscricaoId)

      return {
        resultadoId: item.resultadoId,
        classificacao: index + 1,
        inscricaoId: item.inscricaoId,
        conceito: item.conceito,
        nome: item.nome,
        nomeSocial: item.nomeSocial,
        estaEmpatado: item.estaEmpatado,
        estaEliminado: item.estaEliminado || (fase === this.faseProvaEscrita && desclassificadoPorReporte),
        justificativa: item.justificativa,
        fase: item.fase,
        posicaoMaisRecorrente: item.posicaoMaisRecorrente,
        quantidadeNaPosicaoMaisRecorrente: item.quantidadeNaPosicaoMaisRecorrente,
        nascimento: this.formatarData(nascimento) + ` (${idade} anos)`,
        idade: idade,
        mediaFinal: item.mediaFinal,
        resultados: item.resultados,
        PCD: item.PCD,
        jurado: item.jurado
      }
    })

    if (fase === 'fase1') {
      const oitavo = mappedData.find(item => item.classificacao === 8)
      const mediaOitavo = oitavo?.mediaFinal
      this.mappedDataFase1 = mappedData.map(item => {
        const eliminado = item.classificacao > 8 && item.mediaFinal !== mediaOitavo
        return { ...item, eliminado }
      })
      this.dataSourceFase1.data = this.mappedDataFase1
      this.loadClassificacao(this.mappedDataFase1, 'fase1')
    } else {
      this.mappedDataFase2 = mappedData
      this.dataSourceFase2.data = this.mappedDataFase2
      this.loadClassificacao(this.mappedDataFase2, 'fase2')
    }
  }

  loadClassificacao(dados: any[], fase: 'fase1' | 'fase2') {
    const examinadores = Array.from(
      new Set(dados.flatMap(item => item.resultados.map((r: any) => String(r.comissaoId))))
    ).sort()

    const examinadoresInfo: { [key: string]: { name: string, comissaoId: string, matricula?: string } } = {}
    examinadores.forEach(comissaoId => {
      const examinadorData = dados.flatMap(item => item.resultados)
        .find((r: any) => String(r.comissaoId) === comissaoId)
      if (examinadorData) {
        examinadoresInfo[comissaoId] = {
          name: examinadorData.examinadorNome,
          comissaoId: String(examinadorData.comissaoId),
          matricula: examinadorData.examinadorMatricula
        }
      }
    })

    if (fase === 'fase1') {
      this.examinadoresInfoFase1 = examinadoresInfo
    } else {
      this.examinadoresInfoFase2 = examinadoresInfo
    }

    const colunasClassificacaoGrid = ['posicao', ...examinadores]
    const headerRow = ['posicao']
    examinadores.forEach(comissaoId => {
      headerRow.push(`${comissaoId}_nome`, `${comissaoId}_media`, `${comissaoId}_conceito`)
    })

    const posicoes = Array.from(
      new Set(dados.flatMap(item => item.resultados.map((r: any) => r.posicao)))
    ).sort((a, b) => a - b)

    const dataSourceClassificacao = posicoes.map(pos => {
      const linha: ResultadoClassificacaoLinha = { posicao: pos }
      examinadores.forEach(examinador => {
        const registro = dados.find(item =>
          item.resultados.some((r: any) => r.posicao === pos && String(r.comissaoId) === examinador)
        )
        const candidato = registro?.resultados.find(
          (r: any) => r.posicao === pos && String(r.comissaoId) === examinador
        )
        linha[`${examinador}_nome`] = candidato ? candidato.inscricaoNome : '-'
        linha[`${examinador}_nomeSocial`] = candidato ? candidato.inscricaoNomeSocial : '-'
        linha[`${examinador}_media`] = candidato ? (candidato.mediaFinal?.toFixed(2) ?? '-') : '-'
        linha[`${examinador}_conceito`] = candidato?.conceito || ''
        linha[`${examinador}_justificativa`] = candidato?.justificativa || ''
      })
      return linha
    })

    if (fase === 'fase1') {
      this.colunasClassificacaoGrid = colunasClassificacaoGrid
      this.headerRowFase1 = headerRow
      this.dataSourceClassificacaoFase1.data = dataSourceClassificacao
    } else {
      this.colunasClassificacaoGrid = colunasClassificacaoGrid
      this.headerRowFase2 = headerRow
      this.dataSourceClassificacaoFase2.data = dataSourceClassificacao
    }
  }

  processarResumoNotas(data: any[]) {
    this.tiposProva = [...new Set(data.map(item => item.tipoProva))].sort()
    
    data.forEach(item => {
      if (item.nomeComissaoJulgadora && item.comissaoJulgadoraId) {
        this.comissoesInfo[item.comissaoJulgadoraId] = {
          nome: item.nomeComissaoJulgadora,
          matricula: item.matriculaComissaoJulgadora
        }
      }
    })
    
    this.tiposProva.forEach(tipo => {
      const notasTipo = data.filter(item => item.tipoProva === tipo)
      const comissaoIds = [...new Set(notasTipo.map(item => String(item.comissaoJulgadoraId)))].sort()
      
      this.colunasPorTipo[tipo] = ['inscricaoId', 'nome', ...comissaoIds]
      
      const candidatos = [...new Set(notasTipo.map(item => item.inscricaoId))]
      this.notasPorTipo[tipo] = candidatos.map(inscricaoId => {
        const candidato = notasTipo.find(n => n.inscricaoId === inscricaoId)
        const ocultarNotas = tipo === 'ESCRITA' && this.isDesclassificadoPorReporte(inscricaoId)
        const linha: any = {
          inscricaoId,
          nome: candidato?.nome,
          nomeSocial: candidato?.nomeSocial
        }
        
        comissaoIds.forEach(comissaoId => {
          if (ocultarNotas) {
            linha[comissaoId] = '-'
          } else {
            const nota = notasTipo.find(n => n.inscricaoId === inscricaoId && String(n.comissaoJulgadoraId) === comissaoId)
            linha[comissaoId] = nota?.nota !== undefined ? nota.nota : '-'
          }
        })
        
        return linha
      })
    })
  }

  isDesclassificadoPorReporte(inscricaoId: number): boolean {
    return this.reportesVisiveis.some(r => r.inscricaoId === inscricaoId && r.status === 'DEFERIDA')
  }

  selecionarTipoProva(tipo: string) {
    this.tipoProvaSelecionado = this.tipoProvaSelecionado === tipo ? '' : tipo
  }

  formatarData(dataStr: string): string {
    const data = new Date(dataStr)
    return this.datepipe.transform(data, 'dd/MM/yyyy') ?? ''
  }

  calcularIdade(dataStr: string): number {
    const nascimento = new Date(dataStr)
    const hoje = new Date()
    let idade = hoje.getFullYear() - nascimento.getFullYear()
    const mes = hoje.getMonth() - nascimento.getMonth()
    if (mes < 0 || (mes === 0 && hoje.getDate() < nascimento.getDate())) {
      idade--
    }
    return idade
  }

  getExaminadorDisplayName(comissaoId: string, fase: 'fase1' | 'fase2'): string {
    const info = fase === 'fase1' ? this.examinadoresInfoFase1 : this.examinadoresInfoFase2
    return info[comissaoId]?.name || comissaoId
  }

  getExaminadorMatricula(comissaoId: string, fase: 'fase1' | 'fase2'): string {
    const info = fase === 'fase1' ? this.examinadoresInfoFase1 : this.examinadoresInfoFase2
    return info[comissaoId]?.matricula || ''
  }

  getComissaoMatricula(comissaoId: string): string | undefined {
    return this.comissoesInfo[comissaoId]?.matricula
  }

  getComissaoNome(comissaoId: string): string {
    return this.comissoesInfo[comissaoId]?.nome || comissaoId
  }

  exibirIconePCD(): boolean {
    return this.tipoConcurso !== 'PTPP'
  }

  mostrarJustificativa(justificativa: string): void {
    this.dialog.open(JustificativaInfoDialogComponent, {
      width: '400px',
      data: { justificativa }
    })
  }

  voltar(): void {
    this.router.navigate(['/concurso', this.concursoId, 'classificacao'])
  }
}
